import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const JoinOrganization = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orgName, setOrgName] = useState('');
  const [joining, setJoining] = useState(false);
  const [requestSent, setRequestSent] = useState(false);

  useEffect(() => {
    const fetchInviteInfo = async () => {
      try {
        const res = await fetch(`/api/admin/invite/${code}`);
        if (res.ok) {
          const data = await res.json();
          setOrgName(data.organization_name);
        } else {
          const err = await res.json();
          setError(err.error || 'Ссылка недействительна');
        }
      } catch (e) {
        setError('Ошибка загрузки');
      } finally {
        setLoading(false);
      }
    };
    fetchInviteInfo();
  }, [code]);

  const handleJoin = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      localStorage.setItem('pending_invite', code);
      toast.info('Войдите или зарегистрируйтесь, чтобы подать заявку');
      navigate('/login');
      return;
    }

    setJoining(true);
    try {
      const res = await fetch(`/api/admin/invite/${code}/join`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok) {
        setRequestSent(true);
        toast.success('Заявка отправлена!');
      } else {
        if (data.error === 'Заявка уже подана') {
          setRequestSent(true);
        } else {
          toast.error(data.error || 'Ошибка');
        }
      }
    } catch (e) {
      toast.error('Ошибка');
    } finally {
      setJoining(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-gray-600 dark:text-gray-300">Загрузка...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4">😕</div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Ссылка недействительна</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-4">{error}</p>
          <button onClick={() => navigate('/')} className="px-6 py-2 bg-blue-600 text-white rounded-lg">
            На главную
          </button>
        </div>
      </div>
    );
  }

  if (requestSent) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
          <div className="text-6xl mb-4">⏳</div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Заявка отправлена
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Ваша заявка на вступление в организацию <span className="font-bold text-blue-600">"{orgName}"</span> отправлена на рассмотрение модератору.
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
            Вы получите уведомление, когда заявка будет рассмотрена.
          </p>
          <button onClick={() => navigate('/profile')} className="px-6 py-2 bg-blue-600 text-white rounded-lg">
            Перейти в профиль
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        <div className="text-6xl mb-4">🏢</div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Приглашение в организацию
        </h1>
        <p className="text-lg text-gray-700 dark:text-gray-300 mb-6">
          Вас приглашают присоединиться к организации <span className="font-bold text-blue-600 dark:text-blue-400">"{orgName}"</span>
        </p>
        <button
          onClick={handleJoin}
          disabled={joining}
          className="w-full px-6 py-3 bg-green-600 hover:bg-green-700 text-white text-lg font-semibold rounded-xl transition disabled:opacity-50"
        >
          {joining ? 'Отправка...' : 'Подать заявку'}
        </button>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
          После подачи заявки модератор организации рассмотрит её и примет решение
        </p>
      </div>
    </div>
  );
};

export default JoinOrganization;
